var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',_vm._l((_vm.searchedResources),function(anItem,n){return _c('app-price-card',{key:`apc-${n}`,attrs:{"item":anItem},on:{"myapp-clicked":_vm.handleMyAppClick,"myapp-get-clicked":_vm.handleMyAppGetClick}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }